// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"676c3ea0","831":"912a86c0","977":"2b376dd4"}[chunkId] + ".chunk.js";
};